export const addCopyToQuillHtml = (html) => {
  if (!html) return html;

  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  const paragraphs = wrapper.querySelectorAll("p");

  if (paragraphs.length > 0) {
    const lastP = paragraphs[paragraphs.length - 1];
    lastP.innerHTML += " (copy)";
  } else {
    wrapper.innerHTML += " (copy)";
  }

  return wrapper.innerHTML;
};

export const globalModalProps = {
  title: "Are you sure?",
  okText: "Confirm",
  cancelText: "Cancel",
  okButtonProps: { style: { order: 1 } },
  cancelButtonProps: { style: { order: 2 }, className: "!bg-gray-300 !text-black hover:!bg-gray-400 px-6" },
  footer: (originNode) => <div className="flex justify-end gap-x-2">{originNode}</div>,
  closable: true,
  maskClosable: true,
  centered: true,
};
export const multipleAvail = ["bar", "line", "pie", "table"];
